import React from 'react';

const BreadcrumbOne = () => {
  const breadcrumbContent = {
    title: "Développer",
    subtitle: "Je transforme les idées en expériences numériques percutantes, en proposant des solutions innovantes qui élèvent les marques et captivent les publics du monde entier.",
    imageSrc: "/img/profile.png",
    subheading: "des applications intuitives."
  };

  return (
    <section id="home" className="breadcrumb-section">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-12">
            <div className="content d-flex flex-column justify-content-between">
              <div className="heading w-60">
                <h1 className="title">
                  {breadcrumbContent.title} <img src={breadcrumbContent.imageSrc} alt="Photographer" />
                </h1>
                <div className="flex ms-auto">
                  <span className="line animate-line my-3 my-md-0"></span>
                  <h1 className="title">{breadcrumbContent.subheading}</h1>
                </div>
              </div>
              <p className="sub-title w-50 mt-4 ms-auto">
                {breadcrumbContent.subtitle}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BreadcrumbOne;
